import React, { useContext, useEffect } from "react";

import { Grid, Grow, IconButton, Tooltip } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import TableDefault from "../../../../components/grid/TableDefault";
import Select from "../../../../components/basics/SelectErp";
import { EmissaoContext } from "../contexts/EmissaoContext";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import { Header, Transportadora, Padding } from "../styles/Emissao";
import { useState } from "react";
import ModalEmissaoVolume from "./ModalEmissaoVolume";
import useEmissaoController from "../controllers/EmissaoController";
import SearchSelect from "../../../../components/inputs/SearchSelect";

const TabEmissaoTransportadora = ({ ...props }) => {
  const {
    nfeError,
    transp,
    transpModality,
    setTranspModality,
    transpCnpj,
    setTranspCnpj,
    transpName,
    transpIe,
    setTranspIe,
    transpRntc,
    setTranspRntc,
    transpAddress,
    setTranspAddress,
    transpUf,
    setTranspUf,
    transpCity,
    setTranspCity,
    transpBoardcar,
    setTranspBoardcar,
    transpBoardcarUf,
    setTranspBoardcarUf,
    transpTableSize,
    setTranspTableSize,
    nfeListModalities,
    transpNumber,
    setTranspNumber,
    listCounty,
    listUf,
    loadingInputs,
  } = useContext(EmissaoContext);

  const {
    handleCalcSizes,
    handleConfirmActionItem,
    handleDialogShippingCompany,
    handleSearchSelectShippingCompany,
    handleShippingModality,
  } = useEmissaoController();

  const [modalVolumeOpen, setModalVolumeOpen] = useState(false);
  const [modalTransportadorOpen, setModalTransportadorOpen] = useState(false);
  const [indexSize, setIndexSize] = useState(null);
  const [disabledInput, setDisabledInput] = useState(false);

  const handleEditAndOpenSizes = (indexSize) => {
    setIndexSize(indexSize);
    setModalVolumeOpen(true);
  };

  const handleOpenAddSize = () => {
    setIndexSize(null);
    setModalVolumeOpen(true);
  };

  const handleTranspIe = (value) => {
    setTranspIe(value.replace(/[^0-9]+/g, ""));
  };

  const columnsTableVolume = [
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  handleEditAndOpenSizes(value.index);
                }}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Deletar">
              <IconButton
                onClick={() => {
                  handleConfirmActionItem(
                    value.index,
                    transpTableSize,
                    setTranspTableSize
                  );
                }}
              >
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      align: "center",
      style: { minWidth: 120 },
    },
    {
      label: "Quantidade",
      id: "volQuantidade",
    },
    {
      label: "Espécie",
      id: "volEsp",
    },
    {
      label: "Marca",
      id: "volMarca",
    },
    {
      label: "Numeração",
      id: "volNumeracao",
    },
    {
      label: "Peso Liquido",
      id: "volPesoLiq",
      align: "center",
      style: { minWidth: 150 },
    },
    {
      label: "Peso Bruto",
      id: "volPesoBruto",
      align: "center",
      style: { minWidth: 150 },
    },
  ];

  const columnsTranspSearch = [
    {
      label: "CÓD.",
      id: "id",
    },
    {
      label: "Transportadora",
      id: "razao",
      align: "center",
      style: { minWidth: 400 },
    },
    {
      label: "CPF/CNPJ",
      id: "cnpj_cpf",
      align: "center",
      style: { minWidth: 150 },
    },
    {
      label: "Endereço",
      id: "endereco",
      align: "center",
      style: { minWidth: 280 },
    },
    {
      label: "Bairro",
      id: "bairro",
      align: "center",
      style: { minWidth: 200 },
    },
    {
      label: "Cidade",
      id: "cidade",
      align: "center",
      style: { minWidth: 200 },
    },
    {
      label: "Cep",
      id: "cep",
      align: "center",
      style: { minWidth: 150 },
    },
  ];

  useEffect(() => {
    handleShippingModality(setDisabledInput);
  }, [handleShippingModality]);

  return (
    <>
      {modalVolumeOpen && (
        <ModalEmissaoVolume
          modalVolumeOpen={modalVolumeOpen}
          setModalVolumeOpen={setModalVolumeOpen}
          indexSize={indexSize}
        />
      )}
      {modalTransportadorOpen && (
        <SearchDialog
          open={modalTransportadorOpen}
          setOpen={setModalTransportadorOpen}
          columns={columnsTranspSearch}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleDialogShippingCompany}
          route="prouser/transportadoras/v1"
          title="TRANSPORTADORA"
          filter="razao,id"
          include="estado"
        />
      )}
      <Transportadora>
        <Grid container spacing={2}>
          <Grow in={true}>
            <Grid item sm={6}>
              <Card lineColor="primary" line="left">
                <Header>
                  <Grid container spacing={2}>
                    <Grid item sm={12}>
                      <Select
                        value={transpModality}
                        setValue={setTranspModality}
                        optionsList={nfeListModalities}
                        error={nfeError.transpModality ? true : false}
                        helperText={nfeError.transpModality || ""}
                        descriptionField="label"
                        label="Modalidade do Frete"
                      />
                    </Grid>
                    <Grid
                      item
                      sm={12}
                      justifyContent="center"
                      alignItems="center"
                      container
                    >
                      <Chip
                        label={transpName ? transpName : "TRANSPORTADORA"}
                        bgcolor="secondary"
                      />
                    </Grid>
                    <Grid item xs>
                      <SearchSelect
                        disabled={disabledInput}
                        descriptionField="razao"
                        variant="filled"
                        value={transp}
                        onChange={handleSearchSelectShippingCompany}
                        label="Busca por Razão/Apelido"
                        route="prouser/transportadoras/v1"
                        include="estado"
                        filter="razao"
                        customChange
                      />
                    </Grid>
                    <Grid item>
                      <Btn
                        disabled={disabledInput}
                        onClick={() => {
                          setModalTransportadorOpen(true);
                        }}
                        label={<Icon>search</Icon>}
                      />
                    </Grid>
                  </Grid>
                </Header>
                <Padding padding="20">
                  <Grid container spacing={2}>
                    <Grid item lg={6} sm={12}>
                      <TextField
                        value={transpCnpj}
                        setValue={setTranspCnpj}
                        label="CNPJ/CPF"
                        size="small"
                        disabled={disabledInput}
                        maxLength={14}
                      />
                    </Grid>
                    <Grid item lg={6} sm={6}>
                      <TextField
                        value={transpIe}
                        onChange={(e) => handleTranspIe(e.target.value)}
                        label="I.E"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                    <Grid item lg={12} sm={6}>
                      <TextField
                        value={transpRntc}
                        setValue={setTranspRntc}
                        label="RNTC"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                    <Grid item lg={10} sm={12}>
                      <TextField
                        value={transpAddress}
                        setValue={setTranspAddress}
                        label="Endereço"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                    <Grid item lg={2} sm={12}>
                      <TextField
                        value={transpNumber}
                        setValue={setTranspNumber}
                        label="Nro"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                    <Grid item lg={10} sm={9}>
                      <Select
                        optionsList={listCounty.sort((a, b) =>
                          a.municipio.localeCompare(b.municipio)
                        )}
                        loading={loadingInputs.listCounty || false}
                        value={transpCity}
                        setValue={setTranspCity}
                        label="Município"
                        descriptionField="municipio"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <Select
                        optionsList={listUf.sort((a, b) =>
                          a.estado.localeCompare(b.estado)
                        )}
                        loading={loadingInputs.listUf || false}
                        value={transpUf}
                        setValue={setTranspUf}
                        descriptionField="estado"
                        label="UF"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                    <Grid item lg={10} sm={9}>
                      <TextField
                        value={transpBoardcar}
                        setValue={setTranspBoardcar}
                        label="Placa do Veículo"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={transpBoardcarUf}
                        setValue={setTranspBoardcarUf}
                        label="UF"
                        size="small"
                        disabled={disabledInput}
                      />
                    </Grid>
                  </Grid>
                </Padding>
              </Card>
            </Grid>
          </Grow>
          <Grow in={true} {...(true ? { timeout: 800 } : {})}>
            <Grid item sm={6}>
              <TableDefault
                columns={columnsTableVolume}
                values={transpTableSize}
                maxHeight="330px"
                tableTitle={
                  <Header>
                    <Grid container spacing={2}>
                      <Grid item sm>
                        <Chip label="VOLUMES" bgcolor="secondary" />
                      </Grid>
                      {/* <Grid item>
                        <Btn
                          bgcolor="tertiary"
                          label="Calcular"
                          hovercolor="blue"
                          onClick={handleCalcSizes}
                        />
                      </Grid> */}
                      <Grid item>
                        <Btn
                          startIcon={<Icon>add</Icon>}
                          label="Adicionar"
                          onClick={handleOpenAddSize}
                        />
                      </Grid>
                    </Grid>
                  </Header>
                }
              />
            </Grid>
          </Grow>
        </Grid>
      </Transportadora>
    </>
  );
};

export default TabEmissaoTransportadora;
